import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { Dialog } from "primereact/dialog";
import { deleteItem, setShowDeleteSelected } from "../../store/slices/defectSlice";
import { selectDefectsToDelete, selectDefectDeleteDialog } from "../../store/selectors/defectSelectors";
import { useState } from "react";
import { Button } from "primereact/button";
import { deleteDefect } from "../../services/defectService";

export const DefectDeleteDialog = () => {
    const dispatch = useAppDispatch();

    const toDelete = useAppSelector(selectDefectsToDelete);
    const showDialog = useAppSelector(selectDefectDeleteDialog);

    const [loading, setLoading] = useState(false);

    if (!toDelete) {
        return null;
    }

    const onHide = () => {
        dispatch(setShowDeleteSelected(false));
    };

    const onDelete = async () => {
        if (toDelete.length) {
            setLoading(true);

            const response = await deleteDefect(toDelete);
    
            if (response) {
                dispatch(deleteItem(toDelete));
                onHide();
            }
    
            setLoading(false);
        }
    };

    const footerContent = () => (
        <div className="flex justify-content-end">
            <Button label="Cancel" onClick={onHide} disabled={loading} data-cy="cancel-delete-button"/>
            <Button severity="danger" label={loading ? undefined : "Delete"} icon={loading ? "pi pi-spin pi-spinner" : undefined} onClick={onDelete} disabled={loading} data-cy="confirm-delete-button"/>
        </div>
    );

    return (
        <Dialog header="Delete Selected?" visible={showDialog} className="small-dialog" draggable={false} onHide={onHide} footer={footerContent} data-cy="delete-dialog">
            <p>Are you sure you wish to delete the selected defect(s)?</p>
        </Dialog>
    )
}